import ClickabledRateCardList, { ClickabledRateCardListProps } from './ClickabledRateCardList';

export type { ClickabledRateCardListProps };
export default ClickabledRateCardList;
